import { useFormik } from 'formik';
import { Link } from 'react-router-dom';
import { getAluno, updateAluno } from '../../../api/aluno';
import ErrorMsg, { ErrorApiMsg, SuccessApiMsg } from './error-msg';
import { meuPerfilSchema } from './validation-schema';
import { React, useEffect, useState } from 'react';
import { retrieveToken } from './../../../hooks/use-token';

const MeuPerfilForm = () => {

  const [apiErrors, setApiErrors] = useState(null);
  const [apiSuccess, setApiSuccess] = useState(null);
  const [isSubmting, setIsSubmiting] = useState(false);

  // form
  const handleOnSubmit = (values, { resetForm }) => {
    
    if (isSubmting == false) {

      setIsSubmiting(true);

      setApiErrors(null);
      setApiSuccess(null);

      const tokenApi = retrieveToken();

      updateAluno(tokenApi, {
        "nome": values.name,
        "password": values.password,
        "email": values.email, 
        "cpf": values.cpf,
        "telefone": values.telefone,
        "instagram": values.instagram
      }).then(res => {

        if (res.status) 
          setApiSuccess('Seus dados foram atualizados!');
        else
          setApiErrors(res.error); 
        
          setIsSubmiting(false); 
      });

    }

  }
  
  const [dadosAluno, setDadosAluno] = useState(null);
  
  // use formik
  const { handleChange, handleSubmit, handleBlur, errors, values, touched, setFieldValue } = useFormik({
    initialValues: { name: '', email: '', password: '', cpf: '', telefone: '', instagram: '' },
    validationSchema: meuPerfilSchema,
    onSubmit: handleOnSubmit,
  });

  useEffect(() => {
    
    const tokenApi = retrieveToken();
    
    if (dadosAluno == null) {
      
      getAluno(tokenApi).then(function(result) {
        setDadosAluno(result);
        setFieldValue('name', result.nome);
        setFieldValue('email', result.email);
        setFieldValue('cpf', (result.cpf != null) ? result.cpf : '');
        setFieldValue('telefone', (result.telefone != null) ? result.telefone : '');
        setFieldValue('instagram', (result.instagram != null) ? result.instagram : '');
      });

    }
    
  });
  
  if (dadosAluno != null) {

  return (
    <form onSubmit={handleSubmit}>
    <div className="sign__input-wrapper mb-25">
    <h5>Nome completo</h5>
    <div className="sign__input">
    <input value={values.name} onChange={handleChange} onBlur={handleBlur} type="text"
    placeholder="Nome completo" name='name' />
    <i className="fal fa-user"></i>
    </div>
    {touched.name && <ErrorMsg error={errors.name} />}
    </div>
    
    <div className="sign__input-wrapper mb-25">
    <h5>Alterar sua senha?</h5>
    <div className="sign__input">
    <input onChange={handleChange} onBlur={handleBlur} 
    type="password" placeholder="Digite para alterar sua senha" name='password' />
    <i className="fal fa-user"></i>
    </div>
    {touched.password && <ErrorMsg error={errors.password} />}
    </div>

    <div className="sign__input-wrapper mb-25">
    <h5>Seu email</h5>
    <div className="sign__input">
    <input
    value={values.email ?? dadosAluno?.email ?? ""}
    readOnly
    onChange={handleChange} onBlur={handleBlur}
    type="email" placeholder="Seu e-mail" name='email' />
    <i className="fal fa-envelope"></i>
    </div>
    {touched.email && <ErrorMsg error={errors.email} />}
    </div>

    <div className="sign__input-wrapper mb-25">
    <h5>CPF</h5>
    <div className="sign__input">
    <input value={values.cpf} onChange={handleChange} onBlur={handleBlur} 
    type="text" placeholder="Seu CPF" name='cpf' />
    <i className="fal fa-user"></i>
    </div>
    {touched.cpf && <ErrorMsg error={errors.cpf} />}
    </div>

    <div className="sign__input-wrapper mb-25">
    <h5>Telefone</h5>
    <div className="sign__input">
    <input value={values.telefone} onChange={handleChange} onBlur={handleBlur} 
    type="text" placeholder="Telefone c/ DDD" name='telefone' />
    <i className="fal fa-user"></i>
    </div>
    {touched.telefone && <ErrorMsg error={errors.telefone} />}
    </div>
    
    <div className="sign__input-wrapper mb-25">
    <h5>Instagram</h5>
    <div className="sign__input">
    <input value={values.instagram ?? dadosAluno?.instagram ?? ""} onChange={handleChange} onBlur={handleBlur} 
    type="text" placeholder="@ instagram" name='instagram' />
    <i className="fal fa-user"></i>
    </div>
    {touched.instagram && <ErrorMsg error={errors.instagram} />}
    </div>
    
    <button className="e-btn w-100"> { (isSubmting) ? <span><i className="fal fa-spinner"></i></span> : 'Atualizar dados' } </button>

    {apiErrors && <ErrorApiMsg error={apiErrors} />}

    {apiSuccess && <SuccessApiMsg msg={apiSuccess} />}
    
    </form>
    );

    }

  };
  
  export default MeuPerfilForm;